module.exports = __webpack_public_path__ + "assets/c26043f083b2ffc68d1c5d0584ab4f90.svg";